import { motion } from "framer-motion";
import CuteCountdown from "../Countdown/CuteCountdown";

import "./GuestHome.css";

export default function GuestHome({
  onOpenRsvp,
  onOpenStory,
}) {
  return (
    <main className="guestHome">
      <motion.section
        className="guestHomeContent"
        initial={{ opacity: 0, y: 35 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <p className="guestHomeEyebrow">
          Anjan & Sahana
        </p>

        <h1>
          Where would you
          <br />
          like to begin?
        </h1>

        <p className="guestHomeIntro">
          Celebrate with us, share your memories,
          or step into the little story that brought us here.
        </p>

        <CuteCountdown variant="home" />
        <div className="guestChoiceGrid">

          {/* EVENTS & RSVP */}

          <motion.button
            type="button"
            className="guestChoiceCard rsvpChoiceCard"
            onClick={onOpenRsvp}
            whileHover={{ y: -8 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="guestChoiceIcon">
              ♡
            </span>

            <small>
              November 19–22, 2026
            </small>

            <h2>
              Events & RSVP
            </h2>

            <p>
              View all celebrations, themes,
              timings and send your RSVP.
            </p>

            <strong>
              View celebrations →
            </strong>
          </motion.button>


          {/* OUR STORY */}

          <motion.button
            type="button"
            className="guestChoiceCard storyChoiceCard"
            onClick={onOpenStory}
            whileHover={{ y: -8 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="guestChoiceIcon">
              ✦
            </span>

            <small>
              Hyderabad to Chennai
            </small>

            <h2>
              Our Story
            </h2>

            <p>
              A two-states story, arranged by destiny,
              and the moments that brought us together.
            </p>

            <strong>
              Read our story →
            </strong>
          </motion.button>


          {/* GALLERY */}

          <motion.button
            type="button"
            className="guestChoiceCard galleryChoiceCard"
            onClick={() =>
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSdtsYdfSEhM_K1lYlEoMfT_1Q6ftDhyaYL_jKiQOKNQuMTTFw/viewform?usp=publish-editor",
                "_blank",
                "noopener,noreferrer"
              )
            }
            whileHover={{ y: -8 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="guestChoiceIcon">
              ❀
            </span>

            <small>
              Captured by you
            </small>

            <h2>
              Gallery
            </h2>

            <p>
              Caught a laugh, a dance,
              or a little moment we should never forget?
              Share it with us ♡
            </p>

            <strong>
              Upload memories →
            </strong>
          </motion.button>

        </div>

        <p className="guestHomeFooter">
          Four days. Six celebrations. One forever.
        </p>
      </motion.section>
    </main>
  );
}